import SpriteSymbol from "../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "icon-warn",
  "use": "icon-warn-usage",
  "viewBox": "0 0 12 12",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 12 12\" class=\"design-iconfont\" id=\"icon-warn\">\n  <g fill=\"none\" fill-rule=\"evenodd\">\n    <path fill=\"#E24A4A\" d=\"M5.5 3H6.5V4H5.5z\" />\n    <path fill=\"#E24A4A\" d=\"M5.5 5H6.5V9H5.5z\" />\n    <path stroke=\"#E24A4A\" d=\"M6 0.5A5.5 5.5 0 1 0 6 11.5A5.5 5.5 0 1 0 6 0.5Z\" />\n  </g>\n</symbol>"
});
var result = sprite.add(symbol);
export default symbol